import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    tire_repair: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    speed: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.38 8.57l-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44z"/>
        <path d="M10.59 15.41a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83z"/>
      </svg>
    ),
    build: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    car_repair: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.57,8H17.73L16.15,3.15C15.9,2.45 15.25,2 14.5,2H9.5C8.75,2 8.1,2.45 7.85,3.15L6.27,8H5.43C3.5,8 2,9.5 2,11.43V16C2,16.55 2.45,17 3,17H4C4,18.1 4.9,19 6,19S8,18.1 8,17H16C16,18.1 16.9,19 18,19S20,18.1 20,17H21C21.55,17 22,16.55 22,16V11.43C22,9.5 20.5,8 18.57,8M9.5,4H14.5L15.46,7H8.54L9.5,4M6,15.5A1.5,1.5 0 0,1 4.5,14A1.5,1.5 0 0,1 6,12.5A1.5,1.5 0 0,1 7.5,14A1.5,1.5 0 0,1 6,15.5M18,15.5A1.5,1.5 0 0,1 16.5,14A1.5,1.5 0 0,1 18,12.5A1.5,1.5 0 0,1 19.5,14A1.5,1.5 0 0,1 18,15.5Z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const TireShopsLanding = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'tire shop business'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "Emergency Flat Tire",
      time: "Saturday, 7:45 AM",
      customer: "I have a flat tire on the highway and need roadside assistance. Can someone come help me change it?",
      response: "I understand you're stranded with a flat tire. I'm dispatching our mobile tire service to your location within 30 minutes with a replacement tire and tools.",
      outcome: "$180 mobile service",
      color: "blue"
    },
    {
      type: "Tire Installation",
      time: "Wednesday, 2:15 PM", 
      customer: "I need new tires for my SUV before a road trip this weekend. What brands do you have and can you fit me in?",
      response: "Perfect timing for your road trip! I can schedule tire installation for tomorrow with premium all-season tires. We have Michelin, Goodyear, and Bridgestone in stock.",
      outcome: "$640 tire set + install",
      color: "blue"
    },
    {
      type: "Alignment Service",
      time: "Friday, 4:30 PM",
      customer: "My car is pulling to the right and wearing tires unevenly. I think I need an alignment check.",
      response: "That definitely sounds like an alignment issue which can cause expensive tire wear. I'll schedule our alignment service for Monday with a complete inspection.",
      outcome: "$95 alignment service",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "Emergency tire calls come at all hours. The AI handles them professionally while I focus on getting help to stranded customers.",
      author: "Mike T.",
      business: "Quick Tire Solutions",
      result: "40% more emergency calls"
    },
    {
      quote: "The AI knows all tire sizes and brands. Customers get expert advice about their specific vehicle needs immediately.",
      author: "Sarah L.",
      business: "Professional Tire Center",
      result: "90% conversion rate"
    },
    {
      quote: "Seasonal tire changes create booking rushes. The AI schedules efficiently while I focus on fast, quality service.",
      author: "Carlos R.",
      business: "Expert Tire & Auto",
      result: "60% revenue increase"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'tire shop business' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "AI Receptionist for Tire Shops - 24/7 Emergency & Installation Service",
    "description": "AI receptionist handles tire shop calls for emergency flat tires, installations, alignments, mobile service. Never miss tire service calls.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="AI Receptionist for Tire Shops | 24/7 Emergency & Installation Service"
        description="AI receptionist for tire shops. Handle emergency flat tires, installations, alignments, mobile service 24/7. Never miss tire service calls."
        keywords="tire shop ai receptionist, emergency flat tire, tire installation, wheel alignment, mobile tire service, 24/7 tire shop"
        canonical="https://receptioneer.ai/tire-shops"
        ogTitle="AI Receptionist for Tire Shops - 24/7 Emergency & Installation"
        ogDescription="Handle emergency flat tires, tire installations, and mobile service with AI receptionist. 24/7 response for urgent tire needs."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700 text-white">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
            <div className="px-6 py-12 lg:py-20">
              <div className="inline-flex items-center bg-gray-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                🚗 For Tire Shop Professionals
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
                Never Miss Another
                <br />
                <span className="text-gray-200">Emergency Call</span>
              </h1>
              
              <p className="text-xl text-gray-100 mb-8 leading-relaxed">
                When drivers have flat tires or need replacements, they need immediate help. Your AI receptionist handles emergency roadside service, installations, and alignments 
                <strong className="text-white"> 24/7 with tire expertise.</strong>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <button 
                  onClick={() => setShowWaitlistModal(true)}
                  className="bg-white text-gray-900 hover:bg-gray-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Get Your AI Receptionist →
                </button>
                
                <a
                  href="tel:+17863845350"
                  className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-gray-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
                >
                  <MaterialIcon name="phone" className="w-5 h-5" />
                  Test Tire Shop Call
                </a>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-gray-200 text-sm">Emergency Ready</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">$399</div>
                  <div className="text-gray-200 text-sm">Per Month</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">30 min</div>
                  <div className="text-gray-200 text-sm">Response Time</div>
                </div>
              </div>
            </div>

            <div className="bg-gray-800 lg:bg-transparent px-6 py-12 lg:py-20">
              <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-4 h-4 rounded-full animate-pulse bg-red-500"></div>
                  <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                  <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 font-semibold mb-1">Customer:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].customer}"</div>
                  </div>
                  
                  <div className="rounded-lg p-3 bg-gray-50">
                    <div className="text-xs font-semibold mb-1 text-gray-600">AI Receptionist:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className="text-lg font-black text-green-600">{callExamples[currentCallType].outcome}</div>
                  <div className="text-xs text-gray-500">Service scheduled</div>
                </div>

                <div className="flex justify-center gap-2 mt-6">
                  {callExamples.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        currentCallType === index ? 'bg-gray-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Coverage */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Complete <span className="text-gray-600">Tire Service</span> Coverage
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Emergency Services</h3>
                    <p className="text-gray-700">Flat tire repair, roadside assistance, mobile tire service, and emergency replacements.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="tire_repair" className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Tire Sales & Installation</h3>
                    <p className="text-gray-700">New tire sales, professional installation, balancing, and pressure monitoring systems.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="speed" className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Alignment & Balancing</h3>
                    <p className="text-gray-700">Wheel alignment, tire balancing, rotation services, and suspension inspections.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="car_repair" className="w-8 h-8 text-purple-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Commercial Fleet</h3>
                    <p className="text-gray-700">Fleet tire maintenance, commercial truck tires, and business account management.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="schedule" className="w-8 h-8 text-orange-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Seasonal Services</h3>
                    <p className="text-gray-700">Winter tire installation, summer changeovers, and seasonal tire storage programs.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="build" className="w-8 h-8 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Additional Services</h3>
                    <p className="text-gray-700">Brake service, oil changes, battery replacement, and comprehensive automotive care.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Tire Shop Owners Love <span className="text-gray-600">AI Receptionists</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-gray-50 rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="tire_repair" className="w-8 h-8 text-gray-600" />
                    <div>
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-sm text-gray-600">{testimonial.business}</div>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                  <div className="bg-gray-100 rounded-xl p-4 text-center">
                    <div className="text-lg font-black text-gray-900">{testimonial.result}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section className="py-16 px-6 bg-gray-900 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              One Tire Set Sale Pays for Everything
            </h2>
            
            <p className="text-xl text-gray-100 mb-8">
              A complete tire set typically costs $500-1200+. One missed call could cost you months of AI receptionist service.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-gray-100 mb-6">per month • unlimited calls • 24/7 tire expertise</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-gray-900 hover:bg-gray-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get Your AI Receptionist →
              </button>
            </div>
            
            <p className="text-gray-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Your Tire Shop AI"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">We'll have your tire shop AI ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                  placeholder="e.g. Mike Rodriguez"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                  placeholder="mike@quicktiresolutions.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-gray-900 hover:bg-gray-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get My Tire Shop AI'}
              </button>
            </div>
          )}
        </Modal>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default TireShopsLanding;